import { render, staticRenderFns } from "./ServiceMultiPointResume.vue?vue&type=template&id=0a0853dc&"
import script from "./ServiceMultiPointResume.vue?vue&type=script&lang=js&"
export * from "./ServiceMultiPointResume.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMultiPointResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports